import { TrialUtils } from '../shared/utils/trial/trial-utils';
import { OmapiIdConstants } from '../shared/omapi-id-constants';
var Trial = /** @class */ (function () {
    function Trial() {
    }
    Object.defineProperty(Trial.prototype, "logoUrl", {
        get: function () {
            return TrialUtils.getLogoUrlForTrialOmapiId(this.omapiId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Trial.prototype, "parentOmapiId", {
        get: function () {
            return this.omapiId ? OmapiIdConstants.PRODUCT_TRIAL_MAP.get(this.omapiId) : '';
        },
        enumerable: true,
        configurable: true
    });
    return Trial;
}());
export { Trial };
